// EntitlementProcess enum
export enum EntitlementProcess {
  MANUAL = 'MANUAL',
  SUBSCRIPTION = 'SUBSCRIPTION',
  ORDER = 'ORDER',
  KAW = 'KAW',
  FEDERATED = 'FEDERATED',
}

// EntitlementId type
export type EntitlementId = {
  process: string;
  system: string;
  sourceId: string;
};

export type Claim = {
  brand: string;
  code: string;
  isActive: boolean;
  validFrom?: string; // ISO 8601 date string
  validTo?: string; // ISO 8601 date string
};

// Main Entitlement type
export type Entitlement = {
  id: EntitlementId;
  importedBy: string;
  claims: Claim[];
  roles?: string[];
  modificationTimestamp: string; // ISO 8601 date string
};

export type PutEntitlementDto = {
  claims: Claim[];
  importedBy: string;
  modificationTimeStamp: string;
};
